/* Year of Small Wins — drives the scroll-reveal in ysw-motion.css.
   Additive and defensive: if this script never runs (blocked, errors, slow), content
   stays fully visible — the CSS only hides sections once this adds the ready class. */
(function () {
  'use strict';

  function boot() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sections = document.querySelectorAll('.shopify-section');

    if (reduce || typeof IntersectionObserver !== 'function') {
      sections.forEach(function (el) { el.classList.add('ysw-in'); });
      return;
    }

    document.documentElement.classList.add('ysw-motion-ready');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ysw-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

    sections.forEach(function (el) {
      // a section already in view on load (e.g. the hero) reveals immediately,
      // not after a scroll — matches how the Claude Design mockup felt on first paint
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('ysw-in');
      else io.observe(el);
    });
  }

  // auto-link bare email addresses in page copy (e.g. "hello@yearofsmallwins.com"
  // typed as plain text in admin-authored page content) so they're tappable on
  // mobile without needing every page's content edited by hand.
  function linkEmails() {
    var emailRe = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
    var skipTags = { A: 1, SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, BUTTON: 1 };
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var targets = [];
    var node;
    while ((node = walker.nextNode())) {
      if (skipTags[node.parentNode.tagName]) continue;
      if (emailRe.test(node.nodeValue)) targets.push(node);
      emailRe.lastIndex = 0;
    }
    targets.forEach(function (textNode) {
      var frag = document.createDocumentFragment();
      var lastIndex = 0;
      var match;
      emailRe.lastIndex = 0;
      while ((match = emailRe.exec(textNode.nodeValue))) {
        frag.appendChild(document.createTextNode(textNode.nodeValue.slice(lastIndex, match.index)));
        var a = document.createElement('a');
        a.href = 'mailto:' + match[1];
        a.textContent = match[1];
        frag.appendChild(a);
        lastIndex = match.index + match[1].length;
      }
      frag.appendChild(document.createTextNode(textNode.nodeValue.slice(lastIndex)));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); linkEmails(); });
  else { boot(); linkEmails(); }
})();
